import Immutable from 'immutable';

let widSequence = 0;

let resizeTimer = null;

let openWindows = {};
let windowName;

function onResize() {
	if (windowName) {
		if (resizeTimer) {
			window.clearTimeout(resizeTimer);
		}
		resizeTimer = window.setTimeout(() => {
			localStorage.setItem('window.' + windowName + '.width', window.outerWidth);
			localStorage.setItem('window.' + windowName + '.height', window.outerHeight);
		}, 500);
	}
}

window.openerCallback = function(wid, params, context) {
	if (params === '$closing') {
		delete openWindows[wid];
	} else {
		const ow = openWindows[wid];
		if (ow && ow.callback) {
			ow.callback(params, context);
		}
	}
}

export function closeWindow(wid) {
	const ow = openWindows[wid];
	if (ow) {
		if (ow.wnd) {
			ow.wnd.close();
		}
		delete openWindows[wid];
	}
}

export function setWindowPreference(name, value) {
	const windowName = getWindowName();
	if (wid && windowName) {
		localStorage.setItem('window.' + windowName + '.' + name, value);
	}
}

export function openEntityDetailWindow(type, id) {
	return openWindow('EntityDetail', {
		detailModule: getDetailModule(type),
		getDetailQuery: getDetailQuery(type),
		saveQuery: getDetailSaveQuery(type),
		id
	}, type + 'Detail');
}

export function getWindowPreference(name) {
	const windowName = getWindowName();
	if (wid && windowName) {
		return localStorage.getItem('window.' + windowName + '.' + name);
	}
}


export function processOnUnload() {
	if (wid) {
		localStorage.removeItem('wid.' + wid);
	}
	if (wid && window.opener) {
		window.opener.openerCallback(wid, '$closing');
	}
	for (wid in openWindows) {
		closeWindow(wid);
	}
}

export function callOpener(params, context) {
	if (wid && window.opener) {
		window.opener.openerCallback(wid, params, context);
	}
}

export function openWindow(params, windowName, callback) {
	const wid = ++widSequence;
	let width, height;
	if (windowName) {
		width = localStorage.getItem('window.' + windowName + '.width');
		height = localStorage.getItem('window.' + windowName + '.height');
	}
	if (!width || !height) {
		width = window.innerWidth * 0.8;
		height = window.innerHeight * 0.8;
		if (width > 1200) {
			width = 1200;
		}
		if (height > 900) {
			height = 900;
		}

	}

	const y = window.outerHeight / 2 + window.screenY - (height / 2);
	const x = window.outerWidth / 2 + window.screenX - (width / 2);

	localStorage.setItem('wid.' + wid, JSON.stringify({
		params,
		windowName
	}));
	let wnd = window.open('?wid=' + wid, '_blank', 'location=no,menubar=no,toolbar=no,status=no,width=' + width + ',height=' + height + ',top=' + y + ',left=' + x);
	openWindows[wid] = {
		wnd,
		callback
	};
	return wid;
}

let wid = null;
let windowData = null;

function setWid(value) {
	wid = value;
}

function getWindowName() {
	return windowName;
}

export function initialize(wid) {
	if (wid) {
		setWid(wid);
		windowData = Object.freeze(JSON.parse(localStorage.getItem('wid.' + wid)));
		windowName = windowData.windowName;
		if (windowName) {
			window.onresize = onResize;
		}
	}
}

export function getWindowData() {
	return windowData;
}

export function getParams() {
	return (windowData ? windowData.params : null) || {};
}

